<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.privacy-section-13 class="text-left fw-500">13. Governing Law and Jurisdiction</b-button>
            </b-card-header>
            <b-collapse id="privacy-section-13" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <ol>
                        <li>Governing Law: These terms are governed by the laws of Hong Kong.</li>
                        <li>Jurisdiction: Any legal disputes will be subject to the exclusive jurisdiction of the courts of Hong Kong.</li>
                    </ol>
                </b-card-body>
            </b-collapse>
        </b-card>
      
    </div>
</template>

<script>
  
export default {
    name: 'section-13',
    data() {
        return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:''
        };
    }
};
</script>